import { Component, Input, OnInit } from '@angular/core';
import { DestroyBase } from '../../../../../../components/common/ng-destroy-base';
import { RefListModel } from '../../../../../../models/ref-list-model';
import { RdLocalizedDatePipe } from '../../../../pipes/rd-localized-date.pipe';
import { PeriodOverPeriodLayoutConfigPeriod } from '../period-over-period-models';
import { PeriodOverPeriodWidgetComponent } from '../period-over-period-widget.component';

/**
 * Period over Period slide out
 */
@Component({
  selector: 'period-over-period-slide-out',
  templateUrl: './period-over-period-slide-out.component.html',
  styleUrls: ['./period-over-period-slide-out.component.scss']
})
export class PeriodOverPeriodSlideOutComponent extends DestroyBase implements OnInit {

  /**
   * The widget
   */
  @Input() widget: PeriodOverPeriodWidgetComponent;

  /**
   * The period values
   */
  @Input() periodValues

  /**
   * The periods
   */
  public periods: PeriodOverPeriodLayoutConfigPeriod[];

  /**
   * The reports
   */
  public reports: RefListModel[];

  /**
   * The periodX Id
   */
  public periodXId: number;

  /**
   * Constructor
   */
  constructor(private rdLocalizedDatePipe: RdLocalizedDatePipe) {
      super();
  }

  /**
   * Initializes the component
   */
  ngOnInit() {
    const reportId = this.widget.reportId;
    this.reports = this.periodValues.filter(pv => pv.reportId !== reportId).map(pv => {
      const formattedDate = this.rdLocalizedDatePipe.transform(pv.valuationDate);
      return { oid: pv.reportId, description: `${formattedDate}` };
    });

    this.periods = this.widget.widgetConfig.widgetSettings.layoutConfig;
    this.periodXId = this.periods.find(p => p.isPeriodX).id;
  }

  /**
   * Period visibility change event handler
   */
  public visibilityChanged(_period: PeriodOverPeriodLayoutConfigPeriod) {
    this.widget.updateDisplayData();
  }

  /**
   * Period X change event handler
   */
  public onRadioXSelect(period: PeriodOverPeriodLayoutConfigPeriod) {
    this.periods.forEach(period => period.isPeriodX = false);
    period.isPeriodX = true;
    period.visible = true;
    this.periodXId = period.id;
    this.widget.updateDisplayData();
  }

  /**
   * Period Y change event handler
   */
  public onPeriodYChanged(period: PeriodOverPeriodLayoutConfigPeriod) {
    //periodY checkboxes can all be empty (if we don't want PeriodY to be displayed, or just one selected)

    //clear all others
    this.periods.filter(p => p !== period).forEach(period => period.isPeriodY = false);

    this.widget.updateDisplayData();
  }

  /**
   * Report change event handler
   */
  onReportChanged() {
    this.widget.updateDisplayData();
  }

  /**
   * Hide footnote changed
   */
  hideFootnoteChanged() {
    const hideFootnote = this.periods[0]?.hideFootnote;
    //sync on all periods
    this.periods.forEach(period => period.hideFootnote = hideFootnote);
    this.widget.updateDisplayData();
  }

  /**
   * trackby helper for *ngFor
   * @param _index Index
   * @param period Period item
   * @returns period Id
   */
  public trackByPeriodFn(_index: number, period: PeriodOverPeriodLayoutConfigPeriod): number {
    return period.id;
  }
}
